import {useQuery, UseQueryOptions} from 'react-query'

import {api, queryClient, useMutationQuery, LONG_STALE_QUERY_TIME} from 'base'
import {User, ProfileValues} from 'modules/users'
import {useNoReloadLogout} from 'common/hooks'
import {showSuccessNotification} from 'common/helpers'

export const useGetProfile = (options?: UseQueryOptions<User>) =>
  useQuery<User>(
    'profile',
    async () => {
      const {data} = await api.get('/user/current')
      return data.data
    },
    {...options, staleTime: LONG_STALE_QUERY_TIME}
  )

export const useUpdateProfile = (onClose: () => void) =>
  useMutationQuery<User, any, ProfileValues>(
    'updateProfile',
    async (values) => {
      const {data} = await api.post('/user/current', values)
      return data.data
    },
    {
      onSuccess(data) {
        queryClient.setQueriesData('profile', data)
        queryClient.invalidateQueries('profile')
        showSuccessNotification('Your details has been updated.')
        onClose()
      },
    }
  )

export const useDeleteAccount = () => {
  const logout = useNoReloadLogout()

  return useMutationQuery(
    'deleteAccount',
    async () => {
      await api.delete('/user/current')
    },
    {
      onSuccess() {
        logout()
        showSuccessNotification('Account has been deleted.')
      },
    }
  )
}
